module.exports = __webpack_public_path__ + "images/emoji/finnadie.a06963383cf98607925b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/finnadie.png
// module id = 4fXP
// module chunks = 13